import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Role } from './role.model';
import { environment } from '../../../environments/environment';
import { Page } from '../../models/page-wrapper.model';

@Injectable({
  providedIn: 'root'
})

export class RolesService {
  private apiUrl = `${environment.restApiUrl}roles`;

  constructor(private http: HttpClient) { }

  // Get all roles with pagination
  getAllRoles(params?: any): Observable<Page<Role>> {
    return this.http.get<Page<Role>>(this.apiUrl, { params: params }).pipe(
      catchError(this.handleError)
    );
  }

  // Get role by ID
  getRoleById(id: number): Observable<Role> {
    return this.http.get<Role>(`${this.apiUrl}/${id}`).pipe(
      catchError(this.handleError)
    );
  }

  // Create new role
  createRole(role: Role): Observable<Role> {
    return this.http.post<Role>(this.apiUrl, role).pipe(
      catchError(this.handleError)
    );
  }

  // Update existing role
  updateRole(role: Role): Observable<Role> {
    return this.http.put<Role>(`${this.apiUrl}/${role.id}`, role).pipe(
      catchError(this.handleError)
    );
  }

  // Delete role
  deleteRole(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: any): Observable<never> {
    console.error('An error occurred in RolesService:', error);
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }
}